import { storeToRefs } from "pinia";
import { computed, onMounted } from "vue";

import { useUserLocation } from "shared/composables/useUserLocation";
import { EUROPE, EUROPE_EXCLUDED_LOCATION_IDS } from "shared/constants";
import { getTopLocations } from "shared/helpers/location";
import { useGlobalStore } from "shared/stores/global";

export default function useLocations(organisation = null) {
  const globalStore = useGlobalStore();
  const { locations, isStreem } = storeToRefs(globalStore);
  const { getLocations } = globalStore;

  onMounted(() => {
    getLocations();
  });

  const international = computed(() =>
    locations.value.find((location) => location.type === "Global")
  );

  const isAU = computed(() => isStreem.value);

  const { getUserLocation } = useUserLocation(organisation);

  const topLocations = computed(() =>
    getTopLocations(locations.value, getUserLocation())
  );

  function locationsForParent({ id, name }) {
    return locations.value.filter((location) => {
      const isChild = location.parent_id === id;

      if (name === EUROPE.name) {
        return (
          isChild &&
          !EUROPE_EXCLUDED_LOCATION_IDS.includes(location.country_code)
        );
      }

      return isChild;
    });
  }

  function getSelectedLocations(filteredLocations = []) {
    return locations.value.filter((location) => {
      const isFiltered = filteredLocations.includes(location.id);
      let isParentFiltered = false;

      if (!EUROPE_EXCLUDED_LOCATION_IDS.includes(location.country_code)) {
        isParentFiltered =
          location.parent_id &&
          location.parent_id !== international.value.id &&
          filteredLocations.includes(location.parent_id);
      }

      return !isFiltered && !isParentFiltered && location.type !== "Global";
    });
  }

  return {
    topLocations,
    international,
    isAU,
    locations,
    locationsForParent,
    getSelectedLocations,
  };
}
